import { SERVICES } from "../utils/constants";

const GetServiceByCode = (field,code) => {
    let catchCode;
    let catchType;
    const getObject = SERVICES[SERVICES?.findIndex((item) => item?.field?.code === field)];
    if(getObject !== undefined) {
        getObject?.maintenanceListPerDevice?.map((Obj) => {
            Obj?.maintenanceList?.map((item) => {
                if(item?.code === code) {
                    catchCode = item?.name;
                    catchType = Obj?.device?.name;
                }
            });
        });
    } else {
        return null;
    }
    return [catchType,catchCode];
}

export default GetServiceByCode;